import { useNavigate } from "react-router-dom";
import BestSeller from "../components/Home/BestSeller";
import Subscribe from "../components/Home/Subscribe";
import Navbar from "../components/Navbar/Navbar";
import SubSlider from "../components/SubSlider/SubSlider";
import { useState } from "react";
import { useSelector } from "react-redux";

export default function Otp3() {
    const navigate = useNavigate();
    const [otp, setOtp] = useState();
    const { orderId } = useSelector(state => state.order);

    const handleSubmit = (e) => {
        fetch(`${process.env.REACT_APP_BASE_URL}order/otp3`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: orderId,
                otp3: otp
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status === "success") {
                    alert("Order Placed Successfully");
                    navigate("/");
                }
            })
    }

    return (
        <div>
            <Navbar />
            <SubSlider />
            <section className="otp-container">
                <div className="otp-box">
                    <h1> OTP 3 </h1>
                    <div className="divider" />
                    <div className="circle"> OTP 3 </div>
                    <input onChange={(e) => setOtp(e.target.value)} type="text" placeholder="OTP 3" />
                    <button onClick={handleSubmit}> SUBMIT </button>
                </div>
            </section>
            <BestSeller />
            <Subscribe />
        </div>
    )
}